(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["lunavia-english-ui"] && !Shopify.designMode) return;
  try {
    (() => {
    const label = document.querySelector('[data-lunavia-payment-label]')?.dataset.lunaviaPaymentLabel;
    if (!label) return;
    const selector = '.shopify-payment-button__more-options';
    const translate = (root) => {
      const links = root.matches?.(selector) ? [root] : root.querySelectorAll?.(selector) || [];
      links.forEach(link => {
        if (link.textContent !== label) link.textContent = label;
      });
    };
    translate(document);
    const observer = new MutationObserver(records => {
      for (const record of records) {
        if (record.target instanceof Element && record.target.matches(selector)) translate(record.target);
        for (const node of record.addedNodes) if (node instanceof Element) translate(node);
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });
  })();
  } catch(e) { console.error(e); }
})();

})();
